import RegisterSubtenant from "../views/RegisterSubtenant/RegisterSubtenant";
import Confirm from "../views/RegisterSubtenant/Confirm";
import Vue from "vue";
import Router from "vue-router";

import Meta from "vue-meta";

Vue.use(Router);

Vue.use(Meta, {
  attribute: "kisme-meta",
});

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/:lang(de|en)/",
      name: "register",
      component: RegisterSubtenant,
    },
    {
      name: "registerConfirmed",
      path: "/:lang(de|en)/registerConfirmed",
      component: Confirm,
    },
    {
      name: "fallback",
      path: "**",
      redirect: `en/`,
    },
  ],
});

router.beforeEach((to, from, next) => {
  let lang = to.params["lang"];

  if (lang == null) {
    lang = localStorage.getItem("kisme.lang");

    if (lang == null) {
      lang = "en";
    }
  }

  //changes i18n.local if a change is required
  let changedLanguage = Vue.prototype.$locale.changeIfRequired(lang);
  if (changedLanguage) {
    localStorage.setItem("kisme.lang", lang);
  }

  next();
});

export default router;
